import createSubmit from '../../Form/createSubmitButton.jsx';
import { name } from './OfferAnswerForm.jsx';
export default createSubmit(name);